import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { MenuCommand } from '../../../shared/models/menu-command';

@Component({
    selector: 'ldw-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.css'],
    standalone: false
})
export class MenuComponent {
  @Input() menuItems: MenuCommand[] = [];

  openHelp(cmd: MenuCommand): void {
    if (!cmd.isExternalRoute) {
      return;
    }
    window.open(cmd.route, '_blank');
  }
}
